import moment from 'moment';

const formatDate = (dateStr: string) => {
  return moment(dateStr).format('DD/MM/YYYY');
};

export const stringifyViolations = (violations: any[]) => {
  const violationText = violations
    .map((violation) => {
      return `This voyage takes ${
        violation.deliveryVoyageDurationInDays
      } days, which is impossible for the dates ${formatDate(
        violation.earliestLoadDate
      )} - ${formatDate(violation.latestDischargeDate)}`;
    })
    .join('\n');
  return violationText;
};
